import { useEffect, useState } from "react";
import "../styles/MenuBar.css";
import { get_user_by_id } from "../api/serverWrapper";
import { getData, removeData } from "../utils/localstorage_constants";
import { USER_ID } from "../utils/localstorage_variables";
import { useNavigate } from "react-router-dom";

export default function MenuBar() {

  const navigation = useNavigate()

  let [profile, setProfile] = useState(null);
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    let userid = await getData(USER_ID);
    let userData = await get_user_by_id(userid);
    profile = userData?.data?.user;
    setProfile(profile);
  };

  const Login = () =>{
    navigation("/login")
  }

  const logOut = async () => {
    await removeData();
    window.location.reload();
  };

  return (
    <header className="menu-bar">
      {/* Left: Logo + Text */}
      <div className="menu-left">
        {/* Circle Logo */}
        {/* <div className="menu-logo">HC</div> */}

        {/* Title + Subtitle */}
        <div className="menu-text">
          <h1>3rd-Eye.Tv</h1>
          <p>Video Analysis</p>
        </div>
      </div>

      {/* Right: Star + Login */}
      {profile ? <div className="menu-right">
        {/* <button className="star-btn">★</button> */}
        <button className="star-btn">
          {" "}
          {profile?.FirstName + "   "}
          {profile?.LastName ? profile.LastName : ""}
        </button>

        <button className="logout-btn" onClick={logOut}>
          Log out
        </button>
      </div> : 
      <div className="menu-right">
          
        <button className="logout-btn" onClick={Login}>
          Log in
        </button>
      </div>

      }
    </header>
  );
}
